import React, { Component, Fragment } from 'react';
import enhance from './CompanySettings.enhancer';
import queryString from 'query-string';
import { Grid } from '@material-ui/core';
import ProfilePictureUpload from '../../../components/sign-up/ProfilePictureUpload';
import ChipInput from 'material-ui-chip-input';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { industrySelections } from '../../../constants';
import MenuItem from '@material-ui/core/MenuItem';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import CreateIcon from '@material-ui/icons/Create';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import PersonIcon from '@material-ui/icons/Person';
import PaymentIcon from '@material-ui/icons/Payment';
import LockIcon from '@material-ui/icons/Lock';
import CampanyPaymentSettings from './payments/CompanyPaymentSettings';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import axios from 'axios';

class CompanySettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDeleteAccountModalOpen: false,
      activeIndex: 1,
      editingProfile: false,
      currentProfile: {},
      newProfile: {}
    };
  }

  componentDidMount() {
    // popuate initial data
    this.setState({
      currentProfile: this.props.profile,
      newProfile: this.props.profile
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.profile) {
      this.setState({
        currentProfile: nextProps.profile,
        newProfile: nextProps.profile
      });
    }
  }

  handleActiveIndexChange(newIndex) {
    this.setState({
      activeIndex: newIndex
    });
  }

  editProfile() {
    this.setState({
      editingProfile: true
    });
  }

  cancelProfileEdit() {
    this.setState({
      newProfile: this.state.currentProfile,
      editingProfile: false
    });
  }

  saveProfileEdit() {
    this.props.handleUpdateProfile(this.state.newProfile);
    this.setState({
      editingProfile: false
    });
  }

  handleInterestAdd = chip => {
    this.setState({
      newProfile: {
        ...this.state.newProfile,
        interests: this.state.newProfile.interests
          ? [...this.state.newProfile.interests, chip]
          : [chip]
      }
    });
  };

  deleteAccountClick() {
    this.setState({
      isDeleteAccountModalOpen: true
    });
  }

  handleDeleteAccountAccept() {
    this.props.handleDeleteAccount();
  }

  handleInterestRemove = (chip, index) => {
    this.setState({
      newProfile: {
        ...this.state.newProfile,
        interests: this.state.newProfile.interests
          .slice(0, index)
          .concat(
            this.state.newProfile.interests.slice(
              index + 1,
              this.state.newProfile.interests.length
            )
          )
      }
    });
  };

  handleInfoChange = e => {
    this.setState({
      newProfile: {
        ...this.state.newProfile,
        [e.target.name]: e.target.value
      }
    });
  };

  handleCloseDeleteAccountModal() {
    this.setState({
      isDeleteAccountModalOpen: false
    });
  }

  resetPasswordClick() {
    this.props.resetAccountClickHandler(this.props.profile.email);
  }

  render() {
    const {
      activeIndex,
      editingProfile,
      newProfile,
      managementUrl
    } = this.state;
    const { profile, auth, classes } = this.props;
    return (
      <React.Fragment>
        <div className={classes.layout}>
          <Grid container direction="row" spacing={4}>
            <Grid item className={classes.leftPageDiv}>
              <List component="nav" aria-label="Main mailbox folders">
                <ListItem
                  selected={activeIndex === 1}
                  button
                  onClick={() => this.handleActiveIndexChange(1)}
                >
                  <ListItemIcon className={classes.listIcon}>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="Profile Info" />
                </ListItem>
                <ListItem
                  selected={activeIndex === 2}
                  button
                  onClick={() => this.handleActiveIndexChange(2)}
                >
                  <ListItemIcon className={classes.listIcon}>
                    <PaymentIcon />
                  </ListItemIcon>
                  <ListItemText primary="Payment and Balance" />
                </ListItem>
                <ListItem
                  selected={activeIndex === 3}
                  button
                  onClick={() => this.handleActiveIndexChange(3)}
                >
                  <ListItemIcon className={classes.listIcon}>
                    <LockIcon />
                  </ListItemIcon>
                  <ListItemText primary="Manage Account" />
                </ListItem>
              </List>
            </Grid>
            <Grid item sm xs={12}>
              {activeIndex === 1 && (
                <Paper>
                  <List className={classes.profile_info}>
                    <ListItem className={classes.profile__header}>
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                      >
                        <Grid item>
                          <Typography variant="h6">Profile Info</Typography>
                        </Grid>
                        <Grid item>
                          <Fab
                            size="medium"
                            color="primary"
                            className={classes.button}
                            onClick={this.editProfile.bind(this)}
                          >
                            <CreateIcon fontSize="small" />
                          </Fab>
                        </Grid>
                      </Grid>
                    </ListItem>
                    <Divider />
                    <div
                      className={editingProfile ? '' : classes.settingsOverlay}
                    ></div>
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <ProfilePictureUpload />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <Divider />
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="textSecondary"
                          >
                            Industry
                          </Typography>
                        </Grid>
                        <Grid item>
                          <TextField
                            id="industry"
                            name="industry"
                            select
                            fullWidth
                            value={newProfile.industry}
                            onChange={this.handleInfoChange.bind(this)}
                            SelectProps={{
                              MenuProps: {
                                className: classes.industryMenu
                              }
                            }}
                            margin="normal"
                            variant="outlined"
                            InputProps={{
                              readOnly: !editingProfile
                            }}
                          >
                            {industrySelections.map((item, i) => (
                              <MenuItem key={i} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </Grid>
                    </ListItem>
                    <Divider />
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="textSecondary"
                          >
                            Company Mission
                          </Typography>
                        </Grid>
                        <Grid item>
                          <TextField
                            id="mission"
                            name="mission"
                            variant="outlined"
                            value={newProfile.mission}
                            fullWidth
                            InputProps={{
                              readOnly: !editingProfile
                            }}
                            onChange={this.handleInfoChange.bind(this)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <Divider />
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="textSecondary"
                          >
                            influencer interests
                          </Typography>
                        </Grid>
                        <Grid item>
                          <ChipInput
                            value={
                              newProfile.interests ? newProfile.interests : []
                            }
                            defaultValue={newProfile.interests}
                            className={classes.influencerInterests}
                            onAdd={chip => this.handleInterestAdd(chip)}
                            onDelete={(chip, index) =>
                              this.handleInterestRemove(chip, index)
                            }
                            color="primary"
                            placeholder="type and press enter to add"
                            alwaysShowPlaceholder={false}
                            disabled={!editingProfile}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <Divider />
                    <ListItem className={classes.section}>
                      <Grid container direction="column" justify="center">
                        <Grid item>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="textSecondary"
                          >
                            Target Audience
                          </Typography>
                        </Grid>
                        <Grid item>
                          <TextField
                            id="targetAudience"
                            name="targetAudience"
                            value={newProfile.targetAudience}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                            onChange={this.handleInfoChange.bind(this)}
                            InputProps={{
                              readOnly: !editingProfile
                            }}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    {editingProfile && (
                      <Fragment>
                        <Divider />
                        <ListItem>
                          <Grid container justify="flex-end" spacing={2}>
                            <Grid item>
                              <Button
                                variant="contained"
                                color="secondary"
                                onClick={this.cancelProfileEdit.bind(this)}
                              >
                                Cancel
                              </Button>
                            </Grid>
                            <Grid item>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                onClick={this.saveProfileEdit.bind(this)}
                              >
                                Save
                              </Button>
                            </Grid>
                          </Grid>
                        </ListItem>
                      </Fragment>
                    )}
                  </List>
                </Paper>
              )}
              {activeIndex === 2 && (
                <Paper>
                  <List className={classes.profile_info}>
                    <ListItem className={classes.profile__header}>
                      <Grid
                        container
                        alignItems="center"
                        justify="space-between"
                      >
                        <Grid item>
                          <Typography variant="h6">
                            Payment and Balance
                          </Typography>
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem>
                      <div className={classes.otherPage}>
                        <Grid container justify="center">
                          <CampanyPaymentSettings />
                        </Grid>
                      </div>
                    </ListItem>
                  </List>
                </Paper>
              )}
              {activeIndex === 3 && (
                <React.Fragment>
                  <Paper>
                    <List className={classes.profile_info}>
                      <ListItem className={classes.profile__header}>
                        <Grid
                          container
                          alignItems="center"
                          justify="space-between"
                        >
                          <Grid item>
                            <Typography variant="h6">
                              Manage Password
                            </Typography>
                          </Grid>
                        </Grid>
                      </ListItem>
                      <ListItem>
                        <div className={classes.otherPage}>
                          <Grid container justify="center">
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.resetPasswordButton}
                              onClick={this.resetPasswordClick.bind(this)}
                            >
                              Reset Password
                            </Button>
                          </Grid>
                        </div>
                      </ListItem>
                    </List>
                  </Paper>
                  <Paper>
                    <List className={classes.profile_info_delete}>
                      <ListItem className={classes.profile__header}>
                        <Grid
                          container
                          alignItems="center"
                          justify="space-between"
                        >
                          <Grid item>
                            <Typography variant="h6">Manage Account</Typography>
                          </Grid>
                        </Grid>
                      </ListItem>
                      <ListItem>
                        <div className={classes.otherPage}>
                          <Grid container justify="center">
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={this.deleteAccountClick.bind(this)}
                            >
                              Delete Account
                            </Button>
                          </Grid>
                        </div>
                      </ListItem>
                    </List>
                  </Paper>
                </React.Fragment>
              )}
            </Grid>
          </Grid>
        </div>
        <Dialog
          id="delete-account-dialog"
          open={this.state.isDeleteAccountModalOpen}
          onClose={this.props.handleClose}
          // classes={classes.modalStyles}
          disableAutoFocus={true}
          onBackdropClick={this.handleCloseDeleteAccountModal.bind(this)}
          PaperProps={{
            style: {
              minHeight: '150px',
              minWidth: '350px',
              padding: '20px'
            }
          }}
        >
          <Typography variant="body1" align="center">
            Are you sure you want to permanently delete your account?
          </Typography>
          <div className={classes.deleteButtonsContainer}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={this.handleCloseDeleteAccountModal.bind(this)}
              fullWidth
              className={classes.deleteCancelButtons}
            >
              Cancel
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={this.handleDeleteAccountAccept.bind(this)}
              fullWidth
              className={classes.deleteAcceptButtons}
            >
              Delete
            </Button>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default enhance(CompanySettings);



// WEBPACK FOOTER //
// ./src/components/company/settings/CompanySettings.js